/** @jsx jsx */

import React, { useState } from 'react';
import { css, jsx } from '@emotion/core';
import createInteractionPlaceholder from 'assets/createInteractionPlaceholder.png'; //createInteractionPlaceholder.svg';
import createInteractionPlaceholderPreview from 'assets/createInteractionPlaceholderPreview.svg';
// import NewSectionWizard from 'components/Editor/NewSectionWizard';
import { values } from 'styles/variables';

const { headerHeight } = values;

const EmptySection = () => {
  // const [addNewSection, setAddNewSection] = useState(false);
  //
  return (
    <div
      css={css`
        width: 100%;
        height: 100vh;
        padding: ${headerHeight + 20}px 20px 20px 20px;
        cursor: pointer;
        ${!window.dev() && 'pointer-events: none;'}
      `}
      onClick={() => {
        parent.setNewSectionWizard && parent.setNewSectionWizard(true);
        // setAddNewSection(!addNewSection)
      }}
    >
      <div
        css={css`
          width: 100%;
          height: 100%;
          background: url(${window.dev()
              ? createInteractionPlaceholder
              : createInteractionPlaceholderPreview})
            no-repeat;
          background-size: contain;
          background-position: center;
        `}
      />
      <div
        css={css`
          position: relative;
          top: -30px;
          text-align: center;
          // font-weight: 700;
        `}
      >
        {window.dev() && 'Welcome! Click here to create an interaction.'}
      </div>
      {/* {addNewSection && (
        <NewSectionWizard
          topic={{}}
          onClose={() => {
            setAddNewSection(false);
          }}
        />
      )} */}
    </div>
  );
};

export default EmptySection;
